module.exports = {"devDomains":["^http[s].+lyra-labs\\.fr","^https.\\/\\/krypton.purebilling.io"]}